import { Card, CardSection, CardPermissionFlags } from "tessa/cards";
import { ICardModel, ICardUIExtensionContext } from "tessa/ui/cards";
import { DotNetType, createTypedField, Visibility, Guid } from "tessa/platform";
import { GridViewModel, GridRowAction, ButtonViewModel } from "tessa/ui/cards/controls"; //,GridRowAction //, FileFiltering, FileInternalFiltering
import { showNotEmpty, UIButton } from "tessa/ui";
import { CardRequest, CardService } from "tessa/cards/service";
import { CdRequestTypes } from "../CdRequestTypes";
import { reaction } from "mobx";
import { CdRdStages } from "../CdRdStages";
import { CdUIHelper } from "src/cdScripts/UI/CdUIHelper";
import { CdCommonHelper } from "../CdCommonHelper";
import { IFile } from 'tessa/files';
import { CdRdListHelper } from '../../Helpers/CdRdListHelper';
import { CdCardTypes } from "../CdCardTypes";
import { CdDocStates } from "../CdDocStates";


export class CdTechnicalDocumentationClientHelper {
  // Список контролов, отображаемых, если в карточке РД был выбран объект не по реновации
  static controlNamesIfNotRenovation: string[] =
    [
      "PkPIKProjectGroup",
      "PkCustomerProjectTeam",
      "Gip",
      "PkMainConstructionControl",
      "PkQualityControlSpecialist",
      "PkMechanicalEngineer",
      "PkElectricalEngineer",
      "PkConstructionControlSSEngineer",
      "PkCustomerServiceEngineerHeatSupply",
      "PkCustomerServiceEngineerVK",
      "PkCustomerServiceEngineerSS",
      "PkCustomerServiceEngineerEOM",
      "PtoEngineers"
    ]

  // Список контролов, отображаемых, если в карточке РД был выбран объект по реновации
  static controlNamesIfRenovation: string[] =
    [
      "TDClerk",
      "TDPtoEngineers",
      "TDEngineersGroup",
      "ProjectManagers",
      "Designer"
    ];

  // Список контролов, отображаемых для старого процесса согласования.
  static controlNamesOldAgreementTDProcess: string[] =
    [
      "Uks",
      "UksPto",
      "Gip",
      "Osp",
      "ProjectGroup",
      "ExternalApprovalResponsible",
      "CurrentPerformers",
      "ProductDepartment",
      "AcquaintancedUsers",
      "SignderOfTD",
      "ProjectGroupPM",
      "Designer"
    ];

  public static ReferenceTableLogic(context: ICardUIExtensionContext, _disposer: Function | null) {
    let referencesTableAlias = "RefsTable";
    let referencesGrid = context.model.controls.get(referencesTableAlias) as GridViewModel;
    if (referencesGrid != null) {
      _disposer = reaction(() => referencesGrid.selectedRow, row => {
        if (row!.row != null) {
          let refTypeName = "Обратная ссылка";
          if (row!.row.get("RefTypeName") === refTypeName) {
            context.model.card.permissions.sections.getOrAdd("PkReferencesVirtual").setSectionPermissions(CardPermissionFlags.ProhibitDeleteRow);
          }
          else {
            context.model.card.permissions.sections.getOrAdd("PkReferencesVirtual").setSectionPermissions(CardPermissionFlags.AllowDeleteRow);
          }
        }
      });
    }
  }

  public static TechDocPagesTableLogic(context: ICardUIExtensionContext, disposer: Function | null) {
    let table = context.model.controls.get("TechDocPagesTable") as GridViewModel;
    if (!table) return;

    table.rowInvoked.add(e => {
      if (e.action === GridRowAction.Deleting) {
        e.cancel = true;
        let eorder = e.row.tryGetField("Order")!.$value;
        table!.rows.forEach(row => {
          let order = row.row.tryGetField("Order")!.$value;
          if (order && row.rowId != e.row.rowId && order >= eorder)
            row.row.set("Order", createTypedField(order + 1, DotNetType.Int32))
        });
      }
      if (e.action === GridRowAction.Inserted) {
        e.cancel = true;
      }
    });
    let currentFile: IFile | null = null;
    let currentRowName: string = "лист";
    let fileVirtual = context.model.fileContainer.files.find(x => Guid.equals(x.id, CdRdListHelper.RdListFileID));
    let downloadFile = new UIButton("Сохранить файл",
      async () => {
        if (!currentFile) return;
        await currentFile!.ensureContentLoaded();
        let data = currentFile!.lastVersion.content as Blob;
        // @ts-ignore
        download(data, currentRowName + ".pdf", 'application/pdf');
      });
    downloadFile.setIsEnabled(false);
    table.rightButtons.push(downloadFile);
    if (disposer == null) {
      disposer = reaction(() => table.selectedRows, async () => {
        if (!table.selectedRow) return;
        let row = table.selectedRow!.row;
        let fileID: guid = row.tryGetField("FileID") != null ? row.tryGetField("FileID")!.$value : null;
        let order: number = row.tryGetField("Order") != null ? row.tryGetField("Order")!.$value : null;
        currentRowName = row.tryGetField("Name") != null ? row.tryGetField("Name")!.$value : null
        if (!order || !fileID) return;
        let request = new CardRequest();
        request.requestType = CdRequestTypes.CdSetSelectedTechDocPage;
        request.cardId = context.card.id;
        request.info["Order"] = createTypedField(order, DotNetType.Int32);
        request.info["FileID"] = createTypedField(fileID, DotNetType.Guid);

        //файл клонируется, потому что не понял как очищать кэщ
        currentFile = fileVirtual!.clone(fileVirtual!.source);
        downloadFile.setIsEnabled(currentFile != null);
        let response = await CardService.instance.request(request);
        await showNotEmpty(response.validationResult.build());
        if (!response.validationResult.isSuccessful) {
          return;
        }
        context.model.previewManager.showPreview(currentFile!);
      });
    }

  }


  /** Проверить инвестиционный проект */
  public static CheckIsInvestment(card: Card) {

    let rdSection = card.sections.tryGet("PkRdProperties");
    let isRenovation: boolean =
      rdSection !== null && rdSection !== undefined &&
      rdSection.fields.has("isRenovation") &&
      rdSection.fields.tryGet("isRenovation") != null &&
      rdSection.fields.tryGet("isRenovation") == true;

    let isInvestment: boolean =
      card.typeId == CdCardTypes.TechnicalDocumentationTypeID && !isRenovation;

    return isInvestment;
  }


  // Логика доступности, заполнения и видимости полей
  public static async AvailableAndClearFields(context: ICardUIExtensionContext) {
    let model: ICardModel = context.model;
    let card: Card = context.model.card;
    let pdciSection: CardSection | undefined = card.sections.tryGet('PkDocumentCommonInfo');
    let rdSection: CardSection | undefined = card.sections.tryGet('PkRdProperties');
    let stageID, objectID, rdDivisionID: number | undefined;
    if (!pdciSection || !rdSection) return false;


    //#region Проверка при сохранении
    // if (fromSaving) {
    //   stageID = pdciSection.fields.tryGet('StageID');
    //   let rdSubdivisionID = rdSection.fields.tryGet('RdSubdivisionID');
    //   if (stageID &&
    //       stageID === CdRdStages.WorkingDocumentation &&
    //       !rdSubdivisionID) {
    //         showMessage('Подраздел РД обязателен для заполнения', 'Ошибка');
    //         return false;
    //   } else return true;
    // }
    //#endregion

    //#region Доступность полей при открытии карточки
    stageID = pdciSection.fields.tryGet('StageID');
    objectID = rdSection.fields.tryGet('ObjectID');
    rdDivisionID = rdSection.fields.tryGet('RdDivisionID');
    let cipherIsReadonly: boolean = !(objectID || stageID);
    await this.SetRenovation(card);
    this.SetControlVisibility(card, model);
    this.ReadOnlyFields(model, cipherIsReadonly, ["Cipher"]);
    this.ReadOnlyFields(model, !rdDivisionID, ["RdSubdivisionControl", "ContractDivision", "SubDivision"]);
    this.VisabilityControls(model, stageID === CdRdStages.WorkingDocumentation, ["RdSubdivisionControl"]);
    let stateID = pdciSection.fields.tryGet("StateID");
    if (model.controls.has("RefreshApprovers")) {
      let refreshApprovers = model.controls.get("RefreshApprovers")!;
      if ((stateID == CdDocStates.Project.id || stateID == CdDocStates.Rework.id)
        && card.sections.has("PkContractors")
        && card.permissions.sections.tryGet("PkContractors")?.sectionPermissions == CardPermissionFlags.AllowModify) {
        refreshApprovers.controlVisibility = Visibility.Visible;
        refreshApprovers.block.blockVisibility = Visibility.Visible;
        var button = refreshApprovers as ButtonViewModel;
        if (rdSection) {
          button.onClick = async () => await CdUIHelper.FillApprovers(context, rdSection as CardSection);
        }
      }
    }
    //#endregion

    //#region Доступность, очистка и заполнение полей при смене значений
    pdciSection.fields.fieldChanged.add(async e => {
      if (rdSection && pdciSection) {
        // Изменение поля "Стадия"
        if (e.fieldName === 'StageID') {
          stageID = pdciSection.fields.tryGet('StageID');
          objectID = rdSection.fields.tryGet('ObjectID');
          this.ClearFields(rdSection, ["ContractDivision", "RdDivisionCipher", "RdDivisionID", "RdDivisionName", "SubDivision", "RdSubdivisionCipher", "RdSubdivisionID", "RdSubdivisionName"]);
          this.ReadOnlyFields(model, true, ["RdSubdivisionControl", "ContractDivision", "SubDivision"]);
          this.ReadOnlyFields(model, !objectID || !stageID, ["Cipher"]);
          this.VisabilityControls(model, stageID !== undefined && stageID === CdRdStages.WorkingDocumentation, ["RdSubdivisionControl"]);
        }
      }
    });

    rdSection.fields.fieldChanged.add(async e => {
      if (rdSection && pdciSection) {
        // Изменение поля "Объект"
        if (e.fieldName === 'ObjectID') {
          await this.SetRenovation(card);
          stageID = pdciSection.fields.tryGet('StageID');
          objectID = rdSection.fields.tryGet('ObjectID');
          this.ClearFields(rdSection, ["ContractDivision", "RdDivisionCipher", "RdDivisionID", "RdDivisionName", "SubDivision", "RdSubdivisionCipher", "RdSubdivisionID", "RdSubdivisionName"]);
          this.ReadOnlyFields(model, true, ["RdSubdivisionControl", "ContractDivision", "SubDivision"]);
          this.ReadOnlyFields(model, !objectID || !stageID, ["Cipher"]);
          await this.FillRegionCityAndProject(rdSection, objectID);
          this.SetControlVisibility(card, model);
          await CdUIHelper.FillApprovers(context, rdSection);
        }
        // Изменение поля "Шифр раздела"
        else if (e.fieldName === 'RdDivisionName') {
          stageID = pdciSection.fields.tryGet('StageID');
          rdDivisionID = rdSection.fields.tryGet('RdDivisionID');
          this.ClearFields(rdSection, ["ContractDivision", "SubDivision", "RdSubdivisionCipher", "RdSubdivisionID", "RdSubdivisionName"]);
          this.ReadOnlyFields(model, !rdDivisionID, ["RdSubdivisionControl", "ContractDivision", "SubDivision"]);
          await this.SetRenovation(card);
          await CdUIHelper.FillApprovers(context, rdSection);

          // Предзаполнение шифра и названия раздела (если стадия "Проектная документация")
          if (stageID !== undefined &&
            stageID === CdRdStages.ProjectDocumentation &&
            rdDivisionID !== undefined) {
            this.ReadOnlyFields(model, !rdDivisionID, ["ContractDivision", "SubDivision"]);
            let rdDivisionCipher = rdSection.fields.tryGet('RdDivisionCipher');
            let rdDivisionName = rdSection.fields.tryGet('RdDivisionName');
            rdSection.fields.set('ContractDivision', createTypedField(rdDivisionCipher, DotNetType.String));
            rdSection.fields.set('SubDivision', createTypedField(rdDivisionName, DotNetType.String));
          }
        }
        // Изменение поля "Шифр подраздела"
        else if (e.fieldName === 'RdSubdivisionName') {
          this.ClearFields(rdSection, ["ContractDivision", "SubDivision"]);

          // Предзаполнение шифра и названия подраздела (если стадия "Рабочая документация")
          let rdSubdivisionCipher = rdSection.fields.tryGet('RdSubdivisionCipher');
          let rdSubdivisionName = rdSection.fields.tryGet('RdSubdivisionName');
          rdSection.fields.set('ContractDivision', createTypedField(rdSubdivisionCipher, DotNetType.String));
          rdSection.fields.set('SubDivision', createTypedField(rdSubdivisionName, DotNetType.String));
        }
      }
    });
    //#endregion

    return true;
  }
  private static async SetRenovation(card: Card) {
    var prpSection = card.sections.tryGet("PkRdProperties");
    var objectID = null;

    if (prpSection == null)
      return;

    if ((objectID = prpSection.fields.tryGet("ObjectID")) != null) {
      var request = new CardRequest();
      request.requestType = CdRequestTypes.GetRenovationAndProjectType;
      request.info["ObjectID"] = createTypedField(objectID, DotNetType.Guid);

      const response = await CardService.instance.request(request);

      if (!response.validationResult.isSuccessful)
        return;
      prpSection.fields.set("isRenovation", response.info.IsRenovation)
    }
  }

  /// Устанавливает видимость полей в блоке Участники в зависимости от признака Реновации
  private static SetControlVisibility(card: Card, model: ICardModel) {
    // Сначала скроем всех участников
    CdTechnicalDocumentationClientHelper.controlNamesOldAgreementTDProcess.forEach(controlName => {
      var control = model.controls.get(controlName);
      if (control != null) {
        control.controlVisibility = Visibility.Collapsed
      }
    });

    CdTechnicalDocumentationClientHelper.controlNamesIfRenovation.forEach(controlName => {
      var control = model.controls.get(controlName);
      if (control != null) {
        control.controlVisibility = Visibility.Collapsed
      }
    });

    CdTechnicalDocumentationClientHelper.controlNamesIfNotRenovation.forEach(controlName => {
      var control = model.controls.get(controlName);
      if (control != null) {
        control.controlVisibility = Visibility.Collapsed
      }
    });

    var prpSection = card.sections.tryGet("PkRdProperties");
    let IsRenovation: boolean = prpSection != null
      && prpSection.fields.tryGet("isRenovation") != null
      && prpSection.fields.tryGet("isRenovation") == true;

    // Откроем список участников для реновации или для инвестицонных
    if (IsRenovation) {
      CdTechnicalDocumentationClientHelper.controlNamesIfRenovation.forEach(controlName => {
        var control = model.controls.get(controlName);
        if (control != null)
          control.controlVisibility = Visibility.Visible
      });
    }
    else {
      CdTechnicalDocumentationClientHelper.controlNamesIfNotRenovation.forEach(controlName => {
        var control = model.controls.get(controlName);
        if (control != null)
          control.controlVisibility = Visibility.Visible
      });
    }
  }
  private static async FillRegionCityAndProject(rdPropsSection: CardSection, objectId) {
    if (objectId == null) {
      rdPropsSection.fields.set("RegionID", null);
      rdPropsSection.fields.set("RegionName", null);
      rdPropsSection.fields.set("CityID", null);
      rdPropsSection.fields.set("CityName", null);
      rdPropsSection.fields.set("ProjectID", null);
      rdPropsSection.fields.set("ProjectName", null);
      rdPropsSection.fields.set("ObjectName", null);
      rdPropsSection.fields.set("ObjectPlaceID", null);
      rdPropsSection.fields.set("ObjectPlaceLivingComplex", null);
      rdPropsSection.fields.set("ObjectCategoryID", null);
      rdPropsSection.fields.set("ObjectCategoryName", null);
      return;
    }

    const request = new CardRequest();
    request.requestType = CdRequestTypes.GetRdDivisionRoleProperties;
    request.info["FieldID"] = createTypedField(objectId, DotNetType.Guid);
    request.info["FieldRoleType"] = createTypedField(0, DotNetType.Int32);

    const response = await CardService.instance.request(request);

    await showNotEmpty(response.validationResult.build());
    if (!response.validationResult.isSuccessful) {
      rdPropsSection.fields.set("RegionID", null);
      rdPropsSection.fields.set("RegionName", null);
      rdPropsSection.fields.set("CityID", null);
      rdPropsSection.fields.set("CityName", null);
      rdPropsSection.fields.set("ProjectID", null);
      rdPropsSection.fields.set("ProjectName", null);
      rdPropsSection.fields.set("ObjectName", null);
      rdPropsSection.fields.set("ObjectPlaceID", null);
      rdPropsSection.fields.set("ObjectPlaceLivingComplex", null);
      rdPropsSection.fields.set("ObjectCategoryID", null);
      rdPropsSection.fields.set("ObjectCategoryName", null);
      return;
    }

    CdCommonHelper.SetFieldToSection(rdPropsSection, "RegionID", response.info.RegionID);
    CdCommonHelper.SetFieldToSection(rdPropsSection, "RegionName", response.info.RegionName);
    CdCommonHelper.SetFieldToSection(rdPropsSection, "CityID", response.info.CityID);
    CdCommonHelper.SetFieldToSection(rdPropsSection, "CityName", response.info.CityName);
    CdCommonHelper.SetFieldToSection(rdPropsSection, "ProjectID", response.info.ProjectID);
    CdCommonHelper.SetFieldToSection(rdPropsSection, "ProjectName", response.info.ProjectName);
    CdCommonHelper.SetFieldToSection(rdPropsSection, "ObjectPlaceID", response.info.ResidentialComplexID);
    CdCommonHelper.SetFieldToSection(rdPropsSection, "ObjectPlaceLivingComplex", response.info.ResidentialComplexName);
    CdCommonHelper.SetFieldToSection(rdPropsSection, "ObjectCategoryID", response.info.ObjectCategoryID);
    CdCommonHelper.SetFieldToSection(rdPropsSection, "ObjectCategoryName", response.info.ObjectCategoryName);

  }

  // Очистка значений в полях секции
  private static ClearFields(sections: CardSection, fieldNames: string[]) {
    fieldNames.forEach(fieldName => {
      sections.fields.set(fieldName, null);
    });
  }

  // Установить доступность поля
  private static ReadOnlyFields(model: ICardModel, isReadOnly: boolean, controlNames: string[]) {
    controlNames.forEach(controlName => {
      let control = model.controls.get(controlName);
      if (control != null) control.isReadOnly = isReadOnly;
    });
  }

  // Установить видимость поля
  private static VisabilityControls(model: ICardModel, isVisible: boolean, controlNames: string[]) {
    controlNames.forEach(controlName => {
      let control = model.controls.get(controlName);
      if (control != null) control.controlVisibility =
        isVisible
          ? Visibility.Visible
          : Visibility.Collapsed;
    });
  }
}